// src/pages/Equipment.jsx
import { Helmet } from 'react-helmet-async';

export default function Equipment() {
  const gear = [
    { name: "Blackmagic Cinema Camera 6K Pro", notes: "ProRes / BRAW, ND filters" },
    { name: "RED KOMODO", notes: "6K global shutter, compact rig" },
    { name: "Sony A7S III", notes: "Low-light beast, 10-bit 4:2:2" },
    { name: "Cinematic Lens Set", notes: "Primes + zooms, fast T-stops" },
    { name: "DJI Drone", notes: "4K aerials, stabilized" },
  ];

  return (
    <>
    <Helmet>
      <title>6K Blackmagic Cinema Camera Gear | Blackmagic Films — NJ, PA & NYC</title>
      <meta name="description" content="Blackmagic Films shoots on professional 6K Blackmagic Cinema Cameras, RED KOMODO, cinema lenses, and broadcast-grade audio. Available for productions across New Jersey, Pennsylvania, and New York City." />
      <link rel="canonical" href="https://www.blackmagicfilms.com/equipment" />
      <meta property="og:title" content="6K Blackmagic Cinema Camera Gear | Blackmagic Films" />
      <meta property="og:description" content="Professional 6K cinema camera packages including Blackmagic Cinema Camera 6K Pro and RED KOMODO. Serving NJ, PA, and NYC." />
      <meta property="og:url" content="https://www.blackmagicfilms.com/equipment" />
      <meta property="og:image" content="https://www.blackmagicfilms.com/images/og-image.jpg" />
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.blackmagicfilms.com/" },
          { "@type": "ListItem", "position": 2, "name": "Equipment", "item": "https://www.blackmagicfilms.com/equipment" }
        ]
      })}</script>
    </Helmet>
    <div className="min-h-screen bg-black text-white">
      <section className="max-w-6xl mx-auto p-6 md:p-10">
        <h1 className="text-4xl font-extrabold">Equipment</h1>
        <p className="opacity-70 mt-3">
          A compact, production-ready kit for music videos, live sessions, and cinematic portraits.
        </p>

        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {gear.map((g, i) => (
            <div key={i} className="rounded-2xl border border-white/10 bg-neutral-900 p-5">
              <h3 className="text-xl font-semibold">{g.name}</h3>
              {g.notes && <p className="opacity-70 mt-1 text-sm">{g.notes}</p>}
            </div>
          ))}
        </div>

        {/* Optional add-ons / services */}
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          <div className="rounded-2xl border border-white/10 bg-neutral-900 p-5">
            <h4 className="font-semibold text-lg">Audio & Lighting</h4>
            <p className="opacity-70 text-sm mt-1">
              On-camera mics, lavs, LED panels, softboxes, grip.
            </p>
          </div>
          <div className="rounded-2xl border border-white/10 bg-neutral-900 p-5">
            <h4 className="font-semibold text-lg">Stabilization</h4>
            <p className="opacity-70 text-sm mt-1">
              Gimbal, shoulder rig, monopod/tripod, sliders.
            </p>
          </div>
          <div className="rounded-2xl border border-white/10 bg-neutral-900 p-5">
            <h4 className="font-semibold text-lg">Post</h4>
            <p className="opacity-70 text-sm mt-1">
              DaVinci Resolve color, ProTools/Logic audio polish, delivery in H.264/ProRes.
            </p>
          </div>
        </div>
      </section>
    </div>
    </>
  );
}